import React, { useState, useEffect } from 'react';
import { Button, Drawer, Select, Input } from 'antd';
import map from 'lodash/map';
import includes from 'lodash/includes';

import { FilterIcon } from '@components/icons';
import CalendarDeviceItem from './CalendarDeviceItem';

import { Filter } from '../DevicesPage/hooks/useDevicesFilter';

const { Search } = Input;
const { Option, OptGroup } = Select;

function AddDevicesDrawer({
  t,
  onSearch,
  onFilter,
  filter,
  filters,
  isOpen,
  toggle,
  devices,
  onAdd,
}) {
  const [selectedIds, setIds] = useState([]);
  const filteredDevices = filter(devices, ({ isActivate }) => isActivate);

  const onClick = (id) => () => {
    let newIds = selectedIds.slice();

    if (includes(selectedIds, id)) {
      newIds = filter(selectedIds, (i) => i !== id);
    } else {
      newIds.push(id);
    }

    setIds(newIds);
  };

  const onSave = () => onAdd(selectedIds, toggle);

  useEffect(() => {
    if (!isOpen) {
      setIds([]);
    }
  }, [isOpen]);

  return (
    <Drawer
      title={<h2 className="cal-devices-list__title">{t('devices')}</h2>}
      width={264}
      visible={isOpen}
      onClose={toggle}
      footer={
        <Button
          onClick={onSave}
          disabled={selectedIds.length === 0}
          className="cal-devices-list__save-btn"
          type="primary"
        >
          {t('save')}
        </Button>
      }
    >
      <div className="cal-devices-list__filter">
        <Search onChange={onSearch} placeholder={t('search-by-name')} />
        <Select
          mode="multiple"
          value={filters}
          listHeight={420}
          suffixIcon={<FilterIcon className="devices-filter__select-icon" />}
          className="devices-filter__select"
          placeholder={t('device-filtering')}
          // onChange={onFilter}
          onSelect={onFilter}
          onDeselect={onFilter}
          dropdownClassName="devices-filter__dropdown"
        >
          <Option
            className="devices-filter__option devices-filter__option--reset"
            key={Filter.ANY_STATUS}
            value={Filter.ANY_STATUS}
          >
            <Button
              className="devices-filter__reset-btn"
              type="link"
              onClick={() => onFilter(Filter.ANY_STATUS)}
            >
              {t('any-device-status')}
            </Button>
          </Option>
          <OptGroup label={null}>
            <Option
              className="devices-filter__option"
              key={Filter.ONLINE}
              value={Filter.ONLINE}
            >
              {t('online')}
            </Option>
            <Option
              className="devices-filter__option"
              key={Filter.OFFLINE}
              value={Filter.OFFLINE}
            >
              {t('offline')}
            </Option>
            <Option
              className="devices-filter__option"
              key={Filter.IS_ACTIVATE}
              value={Filter.IS_ACTIVATE}
            >
              {t('not-activated')}
            </Option>
          </OptGroup>
          <Option
            className="devices-filter__option devices-filter__option--reset"
            key={Filter.ANY_OS}
            value={Filter.ANY_OS}
          >
            <Button
              className="devices-filter__reset-btn"
              type="link"
              onClick={() => onFilter(Filter.ANY_OS)}
            >
              {t('any-operating-system')}
            </Button>
          </Option>
          <OptGroup label={null}>
            <Option
              className="devices-filter__option"
              key={Filter.HUMMINGBOARD}
              value={Filter.HUMMINGBOARD}
            >
              Hummingboard
            </Option>
            <Option
              className="devices-filter__option"
              key={Filter.WINDOWS}
              value={Filter.WINDOWS}
            >
              Windows
            </Option>
            <Option
              className="devices-filter__option"
              key={Filter.SSSP}
              value={Filter.SSSP}
            >
              SSSP
            </Option>
            <Option
              className="devices-filter__option"
              key={Filter.ANDROID}
              value={Filter.ANDROID}
            >
              Android
            </Option>
            <Option
              className="devices-filter__option"
              key={Filter.TIZEN}
              value={Filter.TIZEN}
            >
              Tizen
            </Option>
            <Option
              className="devices-filter__option"
              key={Filter.WEBOS}
              value={Filter.WEBOS}
            >
              WebOS
            </Option>
          </OptGroup>
          <Option className="devices-filter__option devices-filter__option--reset">
            <Button
              className="devices-filter__reset-btn"
              type="link"
              onClick={() => onFilter([])}
            >
              {t('clear-all-filters')}
            </Button>
          </Option>
        </Select>
      </div>
      <div className="cal-devices-list">
        {map(filteredDevices, (device, id) => (
          <CalendarDeviceItem
            {...device}
            t={t}
            selectedIds={selectedIds}
            onClick={onClick}
            key={id}
          />
        ))}
      </div>
    </Drawer>
  );
}

export default AddDevicesDrawer;
